export const SEARCH_CLICK_EVENT = 'search:click';

export enum ESearchType {
  List = 'list',
  Map = 'map',
}

export type TSearchClickEventDetail = {
  type: ESearchType;
};

export const dispatchSearchClickEvent = (detail: TSearchClickEventDetail) => {
  const event = new CustomEvent<TSearchClickEventDetail>(SEARCH_CLICK_EVENT, {
    detail,
  });

  document.dispatchEvent(event);
};
